import {useQuery} from '@tanstack/react-query';
import {ScorecardsService} from 'client';
import {getService} from 'utilities';
import {
  HOME_TOP_PRIORITIES_QUERY_KEY,
  TOP_PRIORITIES_STALE_TIME_MS,
} from 'views/home/homeQueryKeys';

/** Live Company-tab North Star metrics for the home Top 5 Priorities tile. */
export const useHomeTopPriorities = ({enabled = true}: {enabled?: boolean} = {}) =>
  useQuery({
    queryKey: HOME_TOP_PRIORITIES_QUERY_KEY,
    queryFn: () =>
      getService(ScorecardsService).homeTopPrioritiesMetricsApiV1ScorecardsHomeTopPrioritiesGet(),
    staleTime: TOP_PRIORITIES_STALE_TIME_MS,
    enabled,
  });
